var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavToggler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.251,
    height: 13.806,
    viewBox: "0 0 23.251 13.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_menu",
    "data-name": "vuesax/linear/menu",
    transform: "translate(-686 -386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(687 387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.239,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H14.239a1,1,0,0,1,1,1A1,1,0,0,1,14.239,1Z",
    fill: "#140c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M21.251,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H21.251a1,1,0,0,1,1,1A1,1,0,0,1,21.251,1Z",
    transform: "translate(0 5.903)",
    fill: "#140c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M21.251,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H21.251a1,1,0,0,1,1,1A1,1,0,0,1,21.251,1Z",
    transform: "translate(0 11.806)",
    fill: "#140c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavToggler);
export default __webpack_public_path__ + "static/media/nav-toggler.8ff8e176ef3fb675f8138b2c263f423f.svg";
export { ForwardRef as ReactComponent };